import React, { useState, useEffect } from 'react';
import { parsePhoneNumber, isValidPhoneNumber, getCountryCallingCode } from 'libphonenumber-js';

const PhoneInput = ({ value, onChange, disabled = false, className = "", placeholder = "Enter phone number" }) => {
  const [displayValue, setDisplayValue] = useState("");
  const [countryCode, setCountryCode] = useState("US");
  const [isValid, setIsValid] = useState(true);

  // Common countries for the dropdown
  const countries = [
    { code: "US", name: "United States", flag: "🇺🇸" },
    { code: "CA", name: "Canada", flag: "🇨🇦" },
    { code: "MX", name: "Mexico", flag: "🇲🇽" },
    { code: "GB", name: "United Kingdom", flag: "🇬🇧" },
    { code: "AU", name: "Australia", flag: "🇦🇺" },
    { code: "DE", name: "Germany", flag: "🇩🇪" },
    { code: "FR", name: "France", flag: "🇫🇷" },
    { code: "IT", name: "Italy", flag: "🇮🇹" },
    { code: "ES", name: "Spain", flag: "🇪🇸" },
    { code: "NL", name: "Netherlands", flag: "🇳🇱" },
    { code: "BR", name: "Brazil", flag: "🇧🇷" },
    { code: "AR", name: "Argentina", flag: "🇦🇷" },
    { code: "CL", name: "Chile", flag: "🇨🇱" },
    { code: "CO", name: "Colombia", flag: "🇨🇴" },
    { code: "PE", name: "Peru", flag: "🇵🇪" },
    { code: "VE", name: "Venezuela", flag: "🇻🇪" },
    { code: "JP", name: "Japan", flag: "🇯🇵" },
    { code: "KR", name: "South Korea", flag: "🇰🇷" },
    { code: "CN", name: "China", flag: "🇨🇳" },
    { code: "IN", name: "India", flag: "🇮🇳" },
    { code: "ZA", name: "South Africa", flag: "🇿🇦" },
    { code: "EG", name: "Egypt", flag: "🇪🇬" },
    { code: "NG", name: "Nigeria", flag: "🇳🇬" },
    { code: "KE", name: "Kenya", flag: "🇰🇪" },
    { code: "RU", name: "Russia", flag: "🇷🇺" },
    { code: "TR", name: "Turkey", flag: "🇹🇷" },
    { code: "PL", name: "Poland", flag: "🇵🇱" },
    { code: "SE", name: "Sweden", flag: "🇸🇪" },
    { code: "NO", name: "Norway", flag: "🇳🇴" },
    { code: "DK", name: "Denmark", flag: "🇩🇰" },
    { code: "FI", name: "Finland", flag: "🇫🇮" },
    { code: "CH", name: "Switzerland", flag: "🇨🇭" },
    { code: "AT", name: "Austria", flag: "🇦🇹" },
    { code: "BE", name: "Belgium", flag: "🇧🇪" },
    { code: "PT", name: "Portugal", flag: "🇵🇹" },
    { code: "IE", name: "Ireland", flag: "🇮🇪" },
    { code: "NZ", name: "New Zealand", flag: "🇳🇿" },
    { code: "SG", name: "Singapore", flag: "🇸🇬" },
    { code: "MY", name: "Malaysia", flag: "🇲🇾" },
    { code: "TH", name: "Thailand", flag: "🇹🇭" },
    { code: "VN", name: "Vietnam", flag: "🇻🇳" },
    { code: "ID", name: "Indonesia", flag: "🇮🇩" },
    { code: "PH", name: "Philippines", flag: "🇵🇭" },
    { code: "IL", name: "Israel", flag: "🇮🇱" },
    { code: "SA", name: "Saudi Arabia", flag: "🇸🇦" },
    { code: "AE", name: "UAE", flag: "🇦🇪" },
    { code: "QA", name: "Qatar", flag: "🇶🇦" },
    { code: "KW", name: "Kuwait", flag: "🇰🇼" },
    { code: "BH", name: "Bahrain", flag: "🇧🇭" },
    { code: "OM", name: "Oman", flag: "🇴🇲" },
    { code: "JO", name: "Jordan", flag: "🇯🇴" },
    { code: "LB", name: "Lebanon", flag: "🇱🇧" },
    { code: "SY", name: "Syria", flag: "🇸🇾" },
    { code: "IQ", name: "Iraq", flag: "🇮🇶" },
    { code: "IR", name: "Iran", flag: "🇮🇷" },
    { code: "AF", name: "Afghanistan", flag: "🇦🇫" },
    { code: "PK", name: "Pakistan", flag: "🇵🇰" },
    { code: "BD", name: "Bangladesh", flag: "🇧🇩" },
    { code: "LK", name: "Sri Lanka", flag: "🇱🇰" },
    { code: "NP", name: "Nepal", flag: "🇳🇵" },
    { code: "BT", name: "Bhutan", flag: "🇧🇹" },
    { code: "MV", name: "Maldives", flag: "🇲🇻" },
    { code: "MM", name: "Myanmar", flag: "🇲🇲" },
    { code: "LA", name: "Laos", flag: "🇱🇦" },
    { code: "KH", name: "Cambodia", flag: "🇰🇭" },
    { code: "MN", name: "Mongolia", flag: "🇲🇳" },
    { code: "KZ", name: "Kazakhstan", flag: "🇰🇿" },
    { code: "UZ", name: "Uzbekistan", flag: "🇺🇿" },
    { code: "KG", name: "Kyrgyzstan", flag: "🇰🇬" },
    { code: "TJ", name: "Tajikistan", flag: "🇹🇯" },
    { code: "TM", name: "Turkmenistan", flag: "🇹🇲" },
    { code: "AZ", name: "Azerbaijan", flag: "🇦🇿" },
    { code: "GE", name: "Georgia", flag: "🇬🇪" },
    { code: "AM", name: "Armenia", flag: "🇦🇲" },
    { code: "BY", name: "Belarus", flag: "🇧🇾" },
    { code: "MD", name: "Moldova", flag: "🇲🇩" },
    { code: "UA", name: "Ukraine", flag: "🇺🇦" },
    { code: "RO", name: "Romania", flag: "🇷🇴" },
    { code: "BG", name: "Bulgaria", flag: "🇧🇬" },
    { code: "HR", name: "Croatia", flag: "🇭🇷" },
    { code: "SI", name: "Slovenia", flag: "🇸🇮" },
    { code: "HU", name: "Hungary", flag: "🇭🇺" },
    { code: "SK", name: "Slovakia", flag: "🇸🇰" },
    { code: "CZ", name: "Czech Republic", flag: "🇨🇿" },
    { code: "EE", name: "Estonia", flag: "🇪🇪" },
    { code: "LV", name: "Latvia", flag: "🇱🇻" },
    { code: "LT", name: "Lithuania", flag: "🇱🇹" },
    { code: "GR", name: "Greece", flag: "🇬🇷" },
    { code: "CY", name: "Cyprus", flag: "🇨🇾" },
    { code: "MT", name: "Malta", flag: "🇲🇹" },
    { code: "LU", name: "Luxembourg", flag: "🇱🇺" },
    { code: "IS", name: "Iceland", flag: "🇮🇸" },
    { code: "AD", name: "Andorra", flag: "🇦🇩" },
    { code: "MC", name: "Monaco", flag: "🇲🇨" },
    { code: "LI", name: "Liechtenstein", flag: "🇱🇮" },
    { code: "SM", name: "San Marino", flag: "🇸🇲" },
    { code: "VA", name: "Vatican City", flag: "🇻🇦" },
    { code: "AL", name: "Albania", flag: "🇦🇱" },
    { code: "MK", name: "North Macedonia", flag: "🇲🇰" },
    { code: "RS", name: "Serbia", flag: "🇷🇸" },
    { code: "ME", name: "Montenegro", flag: "🇲🇪" },
    { code: "BA", name: "Bosnia & Herzegovina", flag: "🇧🇦" },
    { code: "XK", name: "Kosovo", flag: "🇽🇰" }
  ].sort((a, b) => a.name.localeCompare(b.name));

  // Initialize with existing value
  useEffect(() => {
    if (value) {
      try {
        const phoneNumber = parsePhoneNumber(value);
        if (phoneNumber) {
          setCountryCode(phoneNumber.country);
          setDisplayValue(phoneNumber.formatNational());
          setIsValid(true);
        } else {
          setDisplayValue(value);
          // Don't show as invalid during initialization - wait for user interaction
          setIsValid(true);
        }
      } catch (error) {
        setDisplayValue(value);
        // Don't show as invalid during initialization - wait for user interaction
        setIsValid(true);
      }
    }
  }, [value]);

  const handleCountryChange = (newCountryCode) => {
    setCountryCode(newCountryCode);
    if (displayValue) {
      // Re-format the current number with the new country
      try {
        const phoneNumber = parsePhoneNumber(displayValue, newCountryCode);
        if (phoneNumber && isValidPhoneNumber(phoneNumber.number)) {
          setDisplayValue(phoneNumber.formatNational());
          setIsValid(true);
          // Update the parent component with the international format
          onChange(phoneNumber.format('E.164'));
        } else {
          // Don't show as invalid when changing countries - keep current state
          // The number might be valid for the new country format
        }
      } catch (error) {
        // Don't show as invalid when changing countries - keep current state
      }
    }
  };

  const handleInputChange = (inputValue) => {
    // Don't format while typing - just store the raw input
    setDisplayValue(inputValue);
    
    // Always show as valid while typing to avoid red X
    setIsValid(true);
    
    // Send the raw input to parent component while typing
    onChange(inputValue);
  };

  const handleBlur = () => {
    if (displayValue && displayValue.length > 0) {
      try {
        // Try to parse and format the number on blur
        const phoneNumber = parsePhoneNumber(displayValue, countryCode);
        if (phoneNumber && isValidPhoneNumber(phoneNumber.number)) {
          setDisplayValue(phoneNumber.formatNational());
          setIsValid(true);
          onChange(phoneNumber.format('E.164'));
        } else {
          // Only show as invalid if the number is long enough to be a real attempt
          // Most phone numbers need at least 10 digits to be valid
          if (displayValue.length >= 10) {
            setIsValid(false);
          } else {
            // Too short to judge - keep as valid
            setIsValid(true);
          }
        }
      } catch (error) {
        // Only show as invalid if the number is long enough to be a real attempt
        if (displayValue.length >= 10) {
          setIsValid(false);
        } else {
          // Too short to judge - keep as valid
          setIsValid(true);
        }
      }
    }
  };

  return (
    <div className="flex flex-col sm:flex-row">
      {/* Country Code Dropdown */}
      <div className="relative mb-2 sm:mb-0">
        <select
          value={countryCode}
          onChange={(e) => handleCountryChange(e.target.value)}
          disabled={disabled}
          className="w-full sm:w-auto h-full px-3 py-2 border border-gray-300 sm:border-r-0 rounded-md sm:rounded-l-md sm:rounded-r-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 bg-white"
        >
          {countries.map((country) => (
            <option key={country.code} value={country.code}>
              {country.flag} +{getCountryCallingCode(country.code)}
            </option>
          ))}
        </select>
      </div>
      
      {/* Phone Number Input */}
      <input
        type="tel"
        value={displayValue}
        onChange={(e) => handleInputChange(e.target.value)}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder={placeholder}
        className={`w-full sm:flex-1 px-3 py-2 border border-gray-300 sm:border-l-0 rounded-md sm:rounded-l-none sm:rounded-r-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 ${
          !isValid && displayValue && displayValue.length >= 10 ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
        } ${className}`}
      />
      
      {/* Validation indicator */}
      {displayValue && displayValue.length >= 10 && (
        <div className="mt-2 sm:mt-0 sm:ml-2 flex items-center justify-center sm:justify-start">
          {isValid ? (
            <span className="text-green-500 text-sm">✓</span>
          ) : (
            <span className="text-red-500 text-sm">✗</span>
          )}
        </div>
      )}
    </div>
  );
};

export default PhoneInput;
